module.exports = __webpack_public_path__ + "img/mile4.56d7fa41.webp";